import { render, staticRenderFns } from "./CreateNewLearning.vue?vue&type=template&id=34d4c8cc&"
import script from "./CreateNewLearning.vue?vue&type=script&lang=js&"
export * from "./CreateNewLearning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports